import { post, postJson, filePost, postFileDownload } from '@/utils/request';

/******** 内部流转单  Start ********/
// 列表
export const getFlowList = params => {
  return post(`/app/flow/getFlowList`, params);
};
// 详情
export const getFlowInfo = params => {
  return post(`/app/flow/getFlowInfo`, params);
};
/******** 内部流转单  End ********/

/******** 任务分配 Start ********/
// 待分配列表
export const getWaitDistributeList = params => {
  return post(`/app/flow/getWaitDistributeList`, params);
};
// 已分配列表
export const getDistributeList = params => {
  return post(`/app/flow/getDistributeList`, params);
};
// 试验进度列表
export const getTestProcessList = params => {
  return post(`/app/flow/getTestProcessList`, params);
};
// 分配
export const editFlowDeliver = params => {
  return postJson(`/app/flow/editFlowDeliver`, params);
};
// 分配详情
export const getFlowDeliver = params => {
  return post(`/app/flow/getFlowDeliver`, params);
};
// 补送样品
export const editSampleItemNum = params => {
  return postJson(`/app/flow/editSampleItemNum`, params);
};
/******** 任务分配 End ********/

/******** 试验中心 Start ********/
// 待试验
export const getMyFlowDeliverList = params => {
  return post(`/app/flow/getMyFlowDeliverList`, params);
};
// 编辑试验时间
export const editFlowDeliverTestedTime = params => {
  return post(`/app/flow/editFlowDeliverTestedTime`, params);
};
// 检测详情
export const getFlowDeliverDetail = params => {
  return post(`/app/flow/getFlowDeliverDetail`, params);
};
// 提交审核
export const submitFlowDeliverAuth = params => {
  return post(`/app/flow/submitFlowDeliverAuth`, params);
};
/******** 实验中心 End ********/

/******** 审核管理 Start ********/
// 审核列表
export const getAuditList = params => {
  return post(`/app/flow/getAuditList`, params);
};
// 批准列表
export const getApproveList = params => {
  return post(`/app/flow/getApproveList`, params);
};
// 审核/批准操作
export const editFlowState = params => {
  return post(`/app/flow/editFlowState`, params);
};
/******** 审核管理 End ********/

// 下载报告
export const getReportWord = params => {
  return post(`/app/office/getReportWord`, params);
};

// 下载原始记录
export const getOriDataWord = params => {
  return post(`/app/office/getOriDataWord`, params);
};

// #region ******** 历史报告管理 ********
// 列表
export const getFlowOldList = params => {
  return post(`/app/doc/getFlowOldList`, params);
};
// 详情
export const getFlowOld = params => {
  return post(`/app/doc/getFlowOld`, params);
};
// 详情 查询检测日期
export const queryReportOfFront = params => {
  return post(`/app/flow/queryReportOfFront`, params);
};
// 根据报告编号查询 详情
export const getPdfOfFlow = params => {
  return post(`/app/doc/getPdfOfFlow`, params);
};
// 新增、编辑
export const editFlowOld = params => {
  return post(`/app/doc/editFlowOld`, params);
};
// 批量上传报告扫描件
export const uploadFlowOldZip = params => {
  return filePost(`/app/doc/uploadFlowOldZip`, params);
};
// #endregion **** 历史报告管理 ********

// #region ******** 文件下载 ********
// 委托协议书
export const downloadEntrustmentExcel = params => {
  return postFileDownload(`/app/etmt/downloadEntrustmentExcel`, params, { responseType: 'blob' });
};
// 内部流转单
export const downloadFlowExcel = params => {
  return postFileDownload(`/app/flow/downloadFlowExcel`, params, { responseType: 'blob' });
};
// #endregion **** 文件下载 ********

// 样品检测信息，打印合格证
export const getSampleItemList = params => {
  return post(`/app/flow/getSampleItemList`, params);
};

// 试验统计
export const getCheckStat = params => {
  return post(`/app/flow/getCheckStat`, params);
};

// 流转单添加图片
export const editFlowImages = params => {
  return post(`/app/flow/editFlowImages`, params);
};
